/**
 * 性别定义 男-1，女-2
 */

export const genders = {
  UNKNOWN: '0',
  MALE: '1',
  FEMALE: '2',
}

export const genderName = {
  [genders.UNKNOWN]: '未知',
  [genders.MALE]: '男生',
  [genders.FEMALE]: '女生',
}

export const genderCls = {
  [genders.MALE]: 'male',
  [genders.FEMALE]: 'women',
}

export default genders
